import React from 'react';
import { Badge, BadgeProps } from '@fluentui/react-components';
import { ESubmissionStatus } from '../types/submissions.types'; // Adjust path as needed

type SubmissionStatusBadgeProps = {
  status: ESubmissionStatus;
  className?: string;
};

export const formatSubmissionStatus = (value: string) =>
  value
    .replace('_', ' ')
    .toLowerCase()
    .replace(/^\w/, (c) => c.toUpperCase());

const SubmissionStatusBadge = ({ status, className }: SubmissionStatusBadgeProps) => {
  let color: BadgeProps['color'] = 'subtle';

  switch (status) {
    case ESubmissionStatus.IN_PREPARATION:
      color = 'informative';
      break;
    case ESubmissionStatus.DONE:
      color = 'success';
      break;
    case ESubmissionStatus.CANCELED:
      color = 'danger';
      break;
    default:
      break;
  }

  return (
    <Badge color={color} appearance="tint" size="extra-large" className={className}>
      {formatSubmissionStatus(status)}
    </Badge>
  );
};

export default SubmissionStatusBadge;
